import React from "react";
import SectionHeader from "./SectionHeader";
import Checkbox from "./../common/Checkbox";

function NewsletterSection() {
  return (
    <section className="mt-6 w-full max-md:max-w-full">
      <SectionHeader icon="setting-2" title="Newsletter settings" />
      <div className="mt-4 w-full max-md:max-w-full">
        <Checkbox
          label="Yes, I would like to subscribe to the newsletter"
          description="If you would like to receive information or news from jusline.at by email."
        />
        <Checkbox
          label="Yes, I would like to become a beta tester."
          description="As a beta tester you get full access to our tool. in advance"
          className="mt-4"
        />
        <Checkbox
          label="Yes, I would like to receive further information about the A-S-O Tool."
          description="If you would like to receive further information from JUSLINE by email."
          className="mt-4"
        />
      </div>
    </section>
  );
}

export default NewsletterSection;
